/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InviteUserInput
 */
export interface InviteUserInput {
    /**
     * 
     * @type {string}
     * @memberof InviteUserInput
     */
    userEmailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteUserInput
     */
    roleId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InviteUserInput
     */
    isOwner?: boolean;
}

/**
 * Check if a given object implements the InviteUserInput interface.
 */
export function instanceOfInviteUserInput(value: object): value is InviteUserInput {
    return true;
}

export function InviteUserInputFromJSON(json: any): InviteUserInput {
    return InviteUserInputFromJSONTyped(json, false);
}

export function InviteUserInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): InviteUserInput {
    if (json == null) {
        return json;
    }
    return {
        
        'userEmailAddress': json['userEmailAddress'] == null ? undefined : json['userEmailAddress'],
        'roleId': json['roleId'] === undefined ? undefined : json['roleId'] === null ? null : json['roleId'],
        'isOwner': json['isOwner'] == null ? undefined : json['isOwner'],
    };
}

export function InviteUserInputToJSON(json: any): InviteUserInput {
    return InviteUserInputToJSONTyped(json, false);
}

export function InviteUserInputToJSONTyped(value?: InviteUserInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userEmailAddress': value['userEmailAddress'],
        'roleId': value['roleId'],
        'isOwner': value['isOwner'],
    };
}

